import React from 'react';
import { QuestionHeading, QuestionOptionsList } from './QuestionBlockShared';

function SingleChoiceBlock({ block, position }) {
    return (
        <div className="ecx-survey-q">
            <QuestionHeading block={block} position={position} />
            <QuestionOptionsList block={block} control="radio" />
        </div>
    );
}

export default SingleChoiceBlock;
